// screens/LoginScreen.jsx
import React from 'react';
import Formation from '../../components/screens/formation';

function FormationScreen() {
  return (
    <div>
      <Formation />
    </div>
  );
}

export default FormationScreen;